const forms = [
  {
    name: "Details",
    options: [
      {
        name: "Name",
        type: "input",
        form: {
          type: "text",
          name: "name",
          placeholder: "User name",
          class: "",
          value: "",
          required: true,
        },
      },
      {
        name: "Phone",
        type: "input",
        form: {
          type: "text",
          name: "phone",
          placeholder: "User phone",
          class: "",
          value: "",
          required: true,
        },
      },
    ],
  },
  {
    name: "Branch",
    view: "/app/dashboard",
    options: [
      {
        name: "Branch",
        type: "selectandadd",
        path: "/app/settings/branches/add",
        form: {
          name: "branches",
          allowClear: true,
          showSearch: true,
          filterOption: true,
          placeholder: "User branch",
          api: "get-all-branches",
          value: null,
          options: null,
          required: true,
        },
      },
      {
        name: "Role",
        type: "selectandadd",
        path: "/app/settings/roles/add",
        form: {
          name: "role",
          allowClear: true,
          showSearch: true,
          filterOption: true,
          placeholder: "User role",
          api: "get-all-roles",
          value: null,
          options: null,
          required: true,
        },
      },
    ],
  },
  {
    name: "Account",
    options: [
      {
        name: "Email",
        type: "input",
        form: {
          type: "text",
          name: "email",
          placeholder: "User email",
          class: "",
          value: "",
          required: true,
        },
      },
      {
        name: "Password",
        type: "input",
        form: {
          type: "text",
          name: "password",
          placeholder: "User password",
          class: "",
          value: "",
          required: true,
        },
      },
    ],
  },
  {
    name: "Status",
    options: [
      {
        name: "Status",
        type: "select",
        form: {
          name: "status",
          allowClear: false,
          placeholder: "Status",
          value: 1,
          options: [
            {
              value: 1,
              label: "Active",
            },
            {
              value: 0,
              label: "In-active",
            },
          ],
          required: false,
        },
      },
    ],
  },
];

export default forms;
